export enum ExtraProduct {
  FEE = 'FEE',
  DISCOUNT = 'DISCOUNT',
  EXTERNAL_DISCOUNT = 'EXTERNAL_DISCOUNT',
  SERVICE = 'SERVICE',
  ACCOUNTING_CHARGE = 'ACCOUNTING_CHARGE',
}

export enum PickingStatus {
  PICKED = 'picked',
  SUBSTITUTED = 'substituted',
  NOT_AVAILABLE = 'not_available',
  OPEN = 'open',
  QUANTITY_CHANGED = 'quantity_changed',
}

export enum RefundStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
}

export type Product = {
  productType: string
  sku: string
  gtin: number
  quantity: number
  id: string
  allowReplace: boolean
  pickingStatus: PickingStatus
  notes: string[]
  fulfilmentFlags: string[]
  rowPrice: { price: number; priceVat: number }
  offers: [{ name: { [lang: string]: string } }]
  refunds: [
    {
      id: string
      amount: number
      status: string
      amountVat: number
      quantity: number
    }
  ]
  collectedProduct: {
    capturedPrice: { price: number; priceVat: number }
    rowPrice: { price: number; priceVat: number }
    gtin: number
    sku: string
    quantity: number
  }
  extraProduct?: ExtraProduct
}

export type ProductInfo = {
  gtin: string
  extId: string
  name: string
  details: { brandName: string }
}

export type ProductIds = {
  gtin: number
  sku: string
}
export type Refund = {
  row_id: number
  message: string
  type: string
  amount: number
}

export type FeeProduct = {
  name: string
  masterProductId: string
}

export type NutrientDetail = {
  nutrientTypeCode: string
  dailyValueIntakePercent: number
  quantity: number
  quantityUnit: string
  id: string
}

export type Energy = {
  nutrientTypeCode: string
  dailyValueIntakePercent: number
  kjQuantity: number | null
  kCalQuantity: number | null
}

export type MandatoryNutrientDetails = {
  fat: NutrientDetail
  saturatedFat: NutrientDetail
  carbohydrate: NutrientDetail
  sugar: NutrientDetail
  fiber: NutrientDetail
  salt: NutrientDetail
  protein: NutrientDetail
  energy: Energy
}

export type ProductNutrientHeader = {
  id: string
  nutrientBasisQuantity: number
  nutrientBasisQuantityCode: string
  servingSizeDescription: { [lang: string]: string }
  dailyValueIntakeReference: { [lang: string]: string }
  mandatoryNutrientDetails: MandatoryNutrientDetails
  nutrientDetails: NutrientDetail[]
}

export type ProductAttribute = {
  productAttributeName: {
    options: { [lang: string]: string }
    contentLanguage: string
  }
  productAttributeValueNumeric?: number
  productAttributeValueBoolean?: boolean
  productAttributeValueString?: {
    options: { [lang: string]: string }
    contentLanguage: string
  }
  isFacetAttribute: boolean
  productAttributeTypeCode: string
  id: string
}

export type ProductAttributeGroup = {
  productAttributeGroupName: {
    options: { [lang: string]: string }
    contentLanguage: string
  }
  productAttribute: ProductAttribute[]
  id: string
}
